import React from "react";
import { ThemeProvider } from "./src/context/theme-context";
import { Script } from "gatsby";

const WeLoveGoogleTagManager = () => {
  return (<>
    <Script>{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-P9CDNPR6');
    `}</Script>

    <Script>{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-M6SK6P');
    `}</Script>
  </>)
}

const GoogleAds = () => (
  <Script>{`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-751630469');
  `}</Script>
)

const Tidio = () => (
  <Script src="//code.tidio.co/xznp1mdth2nekxygwulubane79dbdjxg.js" />
)

const Klaviyo = () => (<>
  <Script>{`
    var _learnq = window._learnq || [];

    // Klaviyo tracking functions
    function klaviyoTrack(event, properties) {
      try {
        if (window._learnq) {
          window._learnq.push(['track', event, properties]);
          console.log('Klaviyo event tracked:', event, properties);
        }
      } catch (error) {
        console.error('Klaviyo tracking error:', error);
      }
    }

    // Track viewed product
    function trackViewedProduct(product) {
      try {
        if (product && window._learnq) {
          let productValue = 0;
          if (product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount) {
            productValue = parseFloat(product.priceRange.minVariantPrice.amount);
          } else if (product.price) {
            productValue = parseFloat(product.price);
          } else if (product.variants && product.variants.length > 0 && product.variants[0].price) {
            productValue = parseFloat(product.variants[0].price);
          }

          let productImage = '';
          if (product.media && product.media.length > 0) {
            const firstMedia = product.media[0];
            if (firstMedia.mediaContentType === 'IMAGE' && firstMedia.image) {
              if (firstMedia.image.src) {
                productImage = firstMedia.image.src;
              } else if (firstMedia.image.originalSrc) {
                productImage = firstMedia.image.originalSrc;
              }
            }
          }

          if (!productImage && product.featuredImage) {
            if (product.featuredImage.src) {
              productImage = product.featuredImage.src;
            } else if (product.featuredImage.originalSrc) {
              productImage = product.featuredImage.originalSrc;
            } else if (product.featuredImage.url) {
              productImage = product.featuredImage.url;
            }
          }

          if (!productImage && product.images && product.images.length > 0) {
            if (product.images[0].src) {
              productImage = product.images[0].src;
            } else if (product.images[0].originalSrc) {
              productImage = product.images[0].originalSrc;
            } else if (product.images[0].url) {
              productImage = product.images[0].url;
            }
          }

          const properties = {
            'Value': productValue,
            'ProductName': product.title || '',
            'ProductID': product.shopifyId || product.id || '',
            'ProductHandle': product.handle || '',
            'ProductVendor': product.vendor || '',
            'ProductType': product.productType || '',
            'ProductTags': product.tags || [],
            'ProductImage': productImage,
            'ProductURL': window.location.href,
            'Categories': product.collections?.nodes?.map(c => c.title) || []
          };

          klaviyoTrack('Viewed Product', properties);
        }
      } catch (error) {
        console.error('Error tracking viewed product:', error);
      }
    }

    window.klaviyoTrack = klaviyoTrack;
    window.trackViewedProduct = trackViewedProduct;
  `}</Script>
  <Script src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=V3E6LL" />
</>)

const VideoCampaign = () => (
  <Script src='//pixel.mathtag.com/event/js?mt_id=1654266&mt_adid=429207&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=' />
)

const MathTag = () => (
  <Script src='//pixel.mathtag.com/event/js?mt_id=1656545&mt_adid=429207&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=' />
)

const TVSquared = () => (
  <Script>{`
    var _tvq = window._tvq = window._tvq || [];
    (function() {
        var u = (("https:" == document.location.protocol) ? "https://collector-15590.us.tvsquared.com/" : "http://collector-15590.us.tvsquared.com/");
        _tvq.push(['setSiteId', "TV-8145450990-1"]);
        _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
        _tvq.push([function() {
            this.deleteCustomVariable(5, 'page')
        }]);
        _tvq.push(['trackPageView']);
        var d = document,
            g = d.createElement('script'),
            s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.defer = true;
        g.async = true;
        g.src = u + 'tv2track.js';
        s.parentNode.insertBefore(g, s);
    })();
  `}</Script>
)

const PPixel = () => (<>
  {/* Buffalo: */}
  <Script>{`
    var MathTag = {
      version: "1.1",
      delimiter: "[INSERT DELIMITER]",
      previous_url: document.referrer,
      mt_exem: "[INSERT SHA-256 HASHED EMAIL]",
      industry: "Home, Garden & Furniture",
      mt_adid: "429207",
      event_type: "catchall",
      mt_id: "1653163",
      order_id: "[INSERT MACRO]",
      product_brand: "[INSERT MACRO]",
      product_category: "[INSERT MACRO]",
      product_id: "[INSERT MACRO]",
      product_price: "[INSERT MACRO]",
      product_quantity: "[INSERT MACRO]",
      revenue: "[INSERT MACRO]"
    }
  `}</Script>
  <Script src="//pixel.mathtag.com/event/js?mt_pp=1&mt_adid=429207" />

  {/* Rochester: */}
  <Script>{`
    var MathTag = {
      version: "1.1",
      delimiter: "[INSERT DELIMITER]",
      previous_url: document.referrer,
      mt_exem: "[INSERT SHA-256 HASHED EMAIL]",
      industry: "Home, Garden & Furniture",
      mt_adid: "429207",
      event_type: "catchall",
      mt_id: "1653164",
      order_id: "[INSERT MACRO]",
      product_brand: "[INSERT MACRO]",
      product_category: "[INSERT MACRO]",
      product_id: "[INSERT MACRO]",
      product_price: "[INSERT MACRO]",
      product_quantity: "[INSERT MACRO]",
      revenue: "[INSERT MACRO]"
    }
  `}</Script>
  <Script src="//pixel.mathtag.com/event/js?mt_pp=1&mt_adid=429207" />
</>)

const Premion = () => (
  <Script src="https://px.premion.com/pixel.js?pxid=680b94a0a8e493ba9486ae7d" />
)

export const wrapRootElement = ({ element }) => (<>
  {process.env.NODE_ENV === 'production' && (<> {/* Production only */}
    <WeLoveGoogleTagManager />
    <GoogleAds />
    <TVSquared />
    <Premion />
  </>)}

  {process.env.NODE_ENV !== 'development' && (<> {/* Staging and production */}
    <Klaviyo />
    <Tidio />
    <PPixel />
    <VideoCampaign />
    <MathTag />
  </>)}

  <ThemeProvider>
    {element}
  </ThemeProvider>
  </>
);
